import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function ForwardTag() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: 34,
        height: 16,
        backgroundColor: '#DDDDDD',
        borderRadius: '2px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        color: 'rgba(0, 0, 0, 0.54)',
        fontWeight: 400,
        mr: 0.5,
      }}
    >
      {t('FWD')}
    </Box>
  );
}

ForwardTag.propTypes = {
};

export default ForwardTag;
